import React, { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import CenterSpinner from "./CenterSpinner";

/**
 * `/pair` 전용: 로그인 여부와 관계없이 `PairPage`를 보여준다.
 * 데스크톱·WebView 모두 `/pair` 및 로그인의 Vision Pro 항목으로 진입 가능.
 * (`PublicRoute`는 user 있으면 /home 으로 보내므로 여기서는 사용하지 않는다.)
 */
const PairingRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <CenterSpinner
        radius={35}
        thickness={10}
        ariaLabel="Loading"
        speedSec={1.4}
        color="#50B786"
        trackColor="rgba(80, 183, 134, 0.3)"
        arcRatio={0.2}
      />
    );
  }

  return <>{children}</>;
};

export default PairingRoute;
